import { LocalStorageKeys } from './types';

export const getFromLocalStorage = (key: LocalStorageKeys) => {
  return localStorage.getItem(key);
};

export const setLocalStorage = (key: LocalStorageKeys, value: string) => {
  return localStorage.setItem(key, value);
};

export const removeFromLocalStorage = (key: LocalStorageKeys) => {
  return localStorage.removeItem(key);
};

